// extracted by mini-css-extract-plugin
export var button = "_50-7";
export var buttonRow = "_50-6";
export var fadeIn = "_50-1";
export var gradient = "_50-0";
export var panel = "_50-2";
export var panelIn = "_50-3";
export var subtitle = "_50-5";
export var title = "_50-4";